<template>
    <div class="text-dark">
        <h4 class="mb-3 text-center text-dark">
            <b> EVALUACIONES REALIZADAS </b>
        </h4>
        <small>
            <b-table
                small
                :fields="fields"
                :items="items"
            />
        </small>
    </div>
</template>

<script>
import { formatBoolean, formatDateTime } from '@/plugins/complianceScripts/index.js';

export default {
    name: 'PrintableAttemptsTable',

    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
    },

    data() {
        return {
            fields: [
                { key: "student", label: "Estudiante", },
                { key: "evaluation", label: "Evaluación", },
                { key: "course", label: "Curso", },
                { key: "curriculum", label: "Tema", },
                { key: "creationDate", label: "Fecha", formatter: formatDateTime, },
                { key: "approved", label: "Aprobada", formatter: formatBoolean},
                { key: "grade", label: "Calificación", class: "text-end", },
            ],
        }
    },
}
</script>

